export const registratieStats = state => state.registratieStats;
export const rapportages = state => state.rapportages;
